//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { usePreviewOrder, useOCart } from '@bee-hole/coms';
import { SfSteps, SfButton } from '@storefront-ui/vue';
import { onSSR } from "@vue-storefront/core";
import CartPreview from '~/components/Checkout/CartPreview';
import { computed, useRoute, useRouter, onMounted, onBeforeUnmount } from '@nuxtjs/composition-api';
import { usePreviewOrderStore } from '~/stores/previewOrder';
import {
  VSF_CURRENCY_COOKIE
} from '@vue-storefront/core';
const STEPS = {
  shipping: 'Shipping',
  billing: 'Billing',
  payment: 'Payment'
};
import { EventBus } from '@/plugins/eventBus';

export default {
  name: 'Checkout',
  components: {
    SfButton,
    SfSteps,
    CartPreview
  },
  setup(props, context) {
    const { preorder, error: preOrderErr, preview } = usePreviewOrder();
    const previewOrderStore = usePreviewOrderStore();
    const { loading, cart, load: loadCart } = useOCart();
    const route = useRoute();
    const router = useRouter();
    const currentStep = computed(() => route.value.path.split('/').pop());
    const currentStepIndex = computed(() => Object.keys(STEPS).findIndex(s => s === currentStep.value));
    const isThankYou = computed(() => currentStep.value === 'thank-you');
    const address = computed(() => previewOrderStore.address);
    const builing = computed(() => previewOrderStore.builing);
    const previewId = computed(() => previewOrderStore.preview_id);
    const hasInsurance = computed(() => previewOrderStore.hasInsurance);
    const orderNote = computed(() => previewOrderStore.orderNote || '');
    const email = computed(() => previewOrderStore.email || '');
    const handleStepClick = (stepIndex) => {
      const key = Object.keys(STEPS)[stepIndex];
      if (preorder.value && preorder.value.errs && preorder.value.errs.length === 0 && (preOrderErr.value && !preOrderErr.value.load)) {
        router.push(context.root.localePath(`/checkout/${key}`));
      }
    };
    onBeforeUnmount(() => {
      // console.log('----------------卸载 checkout--------------');
      EventBus.$off('PreviewOrder');
    });
    const initShouHuo = () => {
      // console.log('previewOrderStore.shippingMethods', JSON.parse(JSON.stringify(previewOrderStore.shippingMethods)), (!previewOrderStore.shippingMethods || previewOrderStore.shippingMethods?.length === 0));
      if (!previewOrderStore.shippingMethods || previewOrderStore.shippingMethods?.length === 0) {
        // console.log('preorder?.value?.orders', preorder?.value);
        var upShippingMethodStatus = false;
        preorder?.value?.orders.map((order) => {
          if (order?.express?.carryId && order?.shop?.shopId) {
            previewOrderStore.setShippingMethod({
              carry_id: order.express.carryId,
              shop_id: order.shop.shopId
            });
            EventBus.$emit('changeExpress', order.express);
            upShippingMethodStatus = true;
          }
        });
        // console.log('更新物流方式');
        // if (upShippingMethodStatus) {
        //   EventBus.$emit('PreviewOrder', previewOrderStore.shippingMethods);
        // }
      }
    };
    const shoppingList = (() => {
      const list = [];
      cart?.value?.list?.map((item) => {
        const sku = {
          sku_id: item.skuId,
          num: item.num,
          sku_prop: item.properties,
          activity_id: ''
        };
        if (previewOrderStore.services?.[item.skuId]) {
          sku.service_ids = previewOrderStore.services[item.skuId];
        }
        list.push(sku);
      });
      return list;
    });
    const preOrderAdd = async () => {
      // console.log('preOrderAdd ---------start');
      if (!address?.value?.addressId) {
        // console.log('---------------没有address');
        return;
      }
      if (loading?.value) {
        console.error('购物车', loading.value, cart.value);
        return;
      }
      previewOrderStore.initPreviewKey();
      // if (!paymethod?.value?.payWayId) {
      //   console.log('没有支付参数');
      //   return;
      // }
      const userKey = context?.root?.$cookies.get("userKey")
      const tokenkey = context?.root?.$cookies.get("tokenkey")
      const data = {
        address_id: address?.value?.addressId,
        fx_id: '0',
        from_id: tokenkey,
        member_note: orderNote.value,
        shopping_list: shoppingList(),
        combine_pay: true,
        billing_address_id: builing.value?.addressId,
        has_insurance: hasInsurance.value,
        email: email.value
      };
      if (userKey) {
        data.user_id = userKey;
      }
      if (previewOrderStore?.previewKey) {
        data.preview_serial_id = previewOrderStore?.previewKey;
      }
      if (previewOrderStore.shippingMethods && preorder.value && previewOrderStore.shippingMethods.length === preorder.value?.orders?.length) {
        data.express = previewOrderStore.shippingMethods;
      }
      if (previewId?.value) {
        data.preview_id = previewId?.value;
      }
      // if (promoCode?.value) {
      //   data.promo_code = promoCode?.value;
      // }
      if (previewOrderStore?.IdCard && previewOrderStore?.IdCard?.id_number && previewOrderStore?.IdCard?.id_name) {
        data.id_name = previewOrderStore.IdCard.id_name;
        data.id_number = previewOrderStore.IdCard.id_number;
        data.id_type = previewOrderStore.IdCard.id_type;
      } else if (preorder?.value?.hasIdentityCheck && (previewOrderStore?.IdCard?.id_type || previewOrderStore?.IdCard?.id_number || previewOrderStore?.IdCard?.id_name)) {
        // return false;
      }
      if (!preorder?.value?.expressChart || preorder?.value?.expressChart?.length === 0) {
        // console.log('清空预览订单的物流方式');
        previewOrderStore.clearShippingMethods();
      }
      // console.log(previewId?.value, code.value);
      await preview(data);
      initShouHuo();
      // previewOrderStore.setPrepay_id(preorder?.value?.previewId);
      previewOrderStore.setPreview_id(preorder?.value?.previewId);
    };
    onSSR(async () => {
      await loadCart();
      EventBus.$emit('PreviewOrder', cart.value);
    });
    onMounted(async () => {
      // if (!previewOrderStore?.previewKey) {
      // }
      if (route.value.path.indexOf('/checkout') !== -1 && route.value.path.indexOf('/checkout/thank-you') === -1) {
        EventBus.$on('PreviewOrder', (params) => {
          console.log('PreviewOrder', params);
          preOrderAdd();
        });
      }
      if (route.value.path.indexOf('/checkout') !== -1 && route.value.path !== '/checkout/shipping') {
        const currency = context.root.$cookies.get(VSF_CURRENCY_COOKIE);
        if (previewOrderStore.currency && previewOrderStore.currency !== currency) {
          router.push(context.root.localePath('/checkout/shipping'));
        }
      }
    });
    return {
      handleStepClick,
      STEPS,
      currentStepIndex,
      isThankYou,
      currentStep
    };
  }
};
